import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AuthProvider, useAuth } from './auth.jsx';
import Navbar          from './components/Navbar.jsx';
import Dashboard       from './pages/Dashboard.jsx';
import WorkflowEditor  from './pages/WorkflowEditor.jsx';
import WorkflowRuns    from './pages/WorkflowRuns.jsx';
import Login           from './pages/Login.jsx';
import AuthCallback    from './pages/AuthCallback.jsx';
import Settings        from './pages/Settings.jsx';

function Splash() {
  return (
    <div className="h-full flex items-center justify-center gap-2" style={{ background: 'var(--bg)', color: 'var(--text-muted)' }}>
      <Loader2 size={18} className="spin" /> Loading…
    </div>
  );
}

// Gate for the authenticated app shell (with navbar).
function RequireAuth() {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user)   return <Navigate to="/login" replace />;
  return (
    <div className="h-full flex flex-col">
      <Navbar />
      <main className="flex-1 overflow-hidden">
        <Routes>
          <Route path="/"                   element={<Dashboard />} />
          <Route path="/settings"           element={<Settings />} />
          <Route path="/workflows/new"      element={<WorkflowEditor />} />
          <Route path="/workflows/:id"      element={<WorkflowEditor />} />
          <Route path="/workflows/:id/runs" element={<WorkflowRuns />} />
          <Route path="*"                   element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login"         element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/*"             element={<RequireAuth />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
